import type { PromoVideo } from "@shared/types/promo-videos";
import { Player } from "@shared/ui";

import * as st from './styles.module.scss';

interface Props {
    video: PromoVideo
}


export const PresentVideo = ({ video }: Props): JSX.Element => (
    <section className={st.wrap}>
        <div className={st.video}>
            <h3>Презентационное видео</h3>
            <Player video={video} />
        </div>
    </section>

)